"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _index = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "virtualSimulationClass",
  data: function data() {
    return {
      queryGroup: [{
        label: "课程名称",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }
      // {
      //   label: "课程状态",
      //   type: "select",
      //   model: "show_status",
      //   placeholder: "课程状态",
      //   options: [{
      //       name: "已下架",
      //       value: 0,
      //     },
      //     {
      //       name: "已上架",
      //       value: 1,
      //     },
      //   ],
      // },
      ],
      modelData: {
        queryValue: "",
        projectLevel: "",
        show_status: "",
        resourceLibraryType: ""
      },
      defaultColumn: [{
        name: "课程名称",
        prop: "courseName",
        isShow: true,
        width: "100"
      }, {
        name: "课程封面",
        prop: "courseImage",
        isShow: true,
        width: "100",
        isImg: true,
        linkColumn: "courseImage"
        // timeFormat: "dateYMD"
      }, {
        name: "数据来源",
        //
        prop: "newSource",
        isShow: true,
        width: "100",
        isFormats: true
        // timeFormat: "dateYMD"
      }, {
        name: "产业分类",
        prop: "industry",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "行业门类",
        prop: "industryDetail",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "学校",
        prop: "fkCourseEmceeSchool",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "专业大类",
        prop: "fkCourseMajor",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "课程链接",
        prop: "courseLink",
        isShow: true,
        width: "200"
      }, {
        name: "课程来源",
        prop: "origin",
        isShow: true,
        width: "100"
      }, {
        name: "项目级别",
        prop: "courseLevel",
        isShow: true,
        width: "100",
        isFormats: true
        // timeFormat: "dateYMD"
      }, {
        name: "排序",
        prop: "sort",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }

      // {
      //   name: "课程状态",
      //   prop: "showStatus",
      //   isShow: true,
      //   width: "100",
      //   isFormats: true,
      //   // formatters: true
      // }
      ],
      minWidth: 200,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        newSource: [{
          name: "国家平台",
          value: 1
        }, {
          name: "省管理员添加",
          value: 2
        }, {
          name: "学校管理员添加",
          value: 3
        }],
        courseLevel: [{
          name: "国家级",
          value: 1
        }, {
          name: "国家级",
          value: '国家级'
        }, {
          name: "省级",
          value: 2
        }, {
          name: "省级",
          value: "省级"
        }, {
          name: "校级",
          value: 3
        }, {
          name: "校级",
          value: "校级"
        }],
        showStatus: [{
          name: "已上架",
          value: 1
        }, {
          name: "已下架",
          value: 0
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      projectLevel: "",
      checkBoxs: [],
      funBtns: [
      // {
      //   size: "small",
      //   click: "morePut",
      //   name: "批量上架",
      //   type: "success"
      // },
      // {
      //   size: "small",
      //   click: "moreNoPut",
      //   name: "批量下架",
      //   type: "warning"
      // },
      {
        size: "small",
        click: "add",
        name: "新增",
        type: "primary"
      }
      // {
      //   size: "small",
      //   click: "deleteById",
      //   name: "批量删除",
      //   type: "danger"
      // },
      ],
      options: [{
        name: "上架",
        class: "edit",
        option: "toPut",
        span: 3,
        isFuntion: true,
        optionFun: "putnaniu"
      }, {
        name: "下架",
        class: "edit",
        option: "toPut",
        span: 3,
        isFuntion: true,
        optionFun: "noputnaniu"
      }, {
        name: "编辑",
        class: "edit",
        option: "edit",
        span: 3,
        isFuntion: true,
        optionFun: "noEditBtn"
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 3,
        isFuntion: true,
        optionFun: "noEditBtn"
      }],
      isput: {
        idList: [],
        value: 0
      },
      userInfo: {}
    };
  },
  methods: {
    morePut: function morePut() {
      this.isput.idList = this.checkBoxs;
      this.isput.value = 1;
      this.put();
    },
    moreNoPut: function moreNoPut() {
      this.isput.idList = this.checkBoxs;
      this.isput.value = 0;
      this.put();
    },
    toPut: function toPut(e) {
      this.isput.idList.push(e.id);
      e.isPut ? this.isput.value = 0 : this.isput.value = 1;
      this.put();
    },
    put: function put() {
      var _this = this;
      (0, _index.resourcePut)(this.isput).then(function (res) {
        if (res.code == 2000) {
          _this.$message.success(res.msg);
          _this.getList();
        }
      });
    },
    //上架按钮显示判断
    putnaniu: function putnaniu(row, callback) {
      if (row.isPut == 0) {
        callback(true);
      } else {
        callback(false);
      }
    },
    noputnaniu: function noputnaniu(row, callback) {
      if (row.isPut == 1) {
        callback(true);
      } else {
        callback(false);
      }
    },
    noEditBtn: function noEditBtn(row, callback) {
      console.log('bianji', row);
      if (row.newSource != 1) {
        callback(true);
      } else {
        callback(false);
      }
    },
    // 新增
    add: function add() {
      this.$router.push("/webSet/courseSetAdd");
    },
    // 编辑
    edit: function edit(e) {
      console.log("e", e);
      // e.schoolId = e.fkCourseEmceeSchool
      this.$router.push({
        path: "/webSet/courseSetEdit",
        query: {
          val: e,
          courseImage: e.courseImage
        }
      });
    },
    // 模糊搜索新闻分类
    search: function search(val) {
      console.log(val, 'search');
      this.queryValue = val.queryValue;
      this.projectLevel = val.projectLevel;
      this.show_status = val.show_status;
      this.getList();
    },
    // 获取分页列表
    getList: function getList() {
      var _this2 = this;
      (0, _index.resourceList)({
        courseName: this.queryValue,
        courseType: '1',
        schoolId: this.userInfo.roleType == 3 ? this.$store.getters.wShoolInfo.id : '',
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        // projectLevel: this.projectLevel,
        provinceId: this.$store.getters.provinceId,
        showStatus: this.show_status
      }).then(function (res) {
        var data = res.data;
        console.log("data", data);
        _this2.listData = data.list;
        _this2.totalData = data.total;
      });
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this3 = this;
      console.log('row', row);
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _index.resourceDelete)({
          idList: id
        }).then(function () {
          _this3.getList();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消删除。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this4 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getList();
    }
  },
  created: function created() {
    // console.log('this.$store.getters.wShoolInfo.id',this.$store.getters.wShoolInfo.id)
    this.userInfo = JSON.parse(sessionStorage.getItem("info"));
    // console.log('this.userInfo',this.userInfo)
    this.getList();
    var wResourceType = this.$store.getters.wResourceType;
    for (var k in wResourceType) {
      this.queryGroup[2].options.push({
        name: wResourceType[k].name,
        value: wResourceType[k].id
      });
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};